import React from 'react'
import PropTypes from 'prop-types'
import PageTemplate from 'components/page-template'
import * as request from 'services/request'

const styles = {
  table: {
    borderCollapse: 'collapse',
    width: '100%'
  },
  th: {
    backgroundColor: '#f8f8f8',
    fontWeight: 'bold'
  },
  td: {
    padding: '8px',
    border: '1px solid #ddd',
    textAlign: 'left'
  },
  link: {
    color: '#1da1f2',
    textDecoration: 'none'
  }
}

export class ViewParticipants extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      participants: []
    }
  }

  componentDidMount () {
    this.getParticipants()
  }

  async getParticipants () {
    const response = await request.authorized(
      `/participants/competition/${this.props.params.id}`
    )
    const participants = await response.json()
    this.setState({
      participants: participants.sort((a, b) => b.createdAt - a.createdAt)
    })
  }

  render () {
    return (
      <PageTemplate
        title='View Experience Participants'
        description="that's where automagic happens"
        className='br-experience widgetBuilder'
      >
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Widget ID</th>
              <th style={styles.th}>User ID</th>
              <th style={styles.th}>Handle</th>
              <th style={styles.th}>Created At</th>
              <th style={styles.th}>Response Type</th>
              <th style={styles.th}>Optin ID</th>
            </tr>
          </thead>
          <tbody>
            {this.state.participants.map(item => (
              <tr key={item.handle}>
                <td style={styles.td}>{this.props.params.id}</td>
                <td style={styles.td}>{item.user_id}</td>
                <td style={styles.td}>
                  <a
                    href={`https://www.twitter.com/${item.handle}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    style={styles.link}
                  >
                    {item.handle}
                  </a>
                </td>
                <td style={styles.td}>
                  {new Date(item.created_at).toLocaleString()}
                </td>
                <td style={styles.td}>{item.response_type}</td>
                <td style={styles.td}>
                  <a
                    href={`https://www.twitter.com/${item.handle}/status/${item.optin_id}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    style={styles.link}
                  >
                    {item.optin_id}
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </PageTemplate>
    )
  }
}

ViewParticipants.propTypes = {
  params: PropTypes.shape({ id: PropTypes.string })
}

export default ViewParticipants



// WEBPACK FOOTER //
// ./src/pages/widgets/participants.js